module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "min-h-dvh flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4 pb-8",
    attrs: {
      "icon": "gear"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('span', [_vm._v("Configuration")])])])], 1), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "p-4 space-y-6"
  }, [_c('section', {
    class: {
      'hidden': _vm.activeSection !== 'start'
    },
    attrs: {
      "id": "start-config"
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-xl shadow-lg p-6 text-center"
  }, [_c('h2', {
    staticClass: "text-2xl md:text-3xl font-bold text-primary mb-4"
  }, [_vm._v("\n                        Bonjour "), _c('strong', [_vm._v(_vm._s(_vm.user.last_name + ' ' + _vm.user.first_name))]), _vm._v(" !\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-md md:text-lg text-gray-700 mb-6"
  }, [_vm._v("\n                        Bienvenue sur la page de configuration de votre "), _c('strong', [_vm._v("application F.i360°")]), _vm._v(".\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-lg py-4 px-6 flex items-center justify-center gap-3",
    attrs: {
      "id": "next-trigger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToSection('add-signature')
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-tools bg-white"
  }), _vm._v(" "), _c('span', [_vm._v("Configurer")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arrow-right bg-white"
  })])])]), _vm._v(" "), _c('section', {
    class: {
      'hidden': _vm.activeSection !== 'add-signature'
    },
    attrs: {
      "id": "add-signature"
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-xl shadow-lg p-6"
  }, [_c('div', {
    staticClass: "text-center mb-6"
  }, [_c('i', {
    staticClass: "inline-block h-10 w-10 mask mask-sign bg-secondary mb-4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-xl font-bold text-primary mb-3 uppercase"
  }, [_vm._v("Ma signature")]), _vm._v(" "), _c('p', {
    staticClass: "text-md text-gray-700"
  }, [_vm._v("\n                            Afin de pouvoir signer numériquement vos rapports d'interventions, merci d'enregistrer votre signature manuscrite.\n                        ")])]), _vm._v(" "), _c('button', {
    staticClass: "w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-md py-4 px-6 flex items-center justify-center gap-3",
    attrs: {
      "id": "signature-trigger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal = true
      }
    }
  }, [_c('span', [_c('strong', [_vm._v("Enregistrer")]), _vm._v(" ma signature")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arrow-right bg-white"
  })])]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "signatureUpdated": _vm.saveSignature
    }
  })], 1), _vm._v(" "), _c('section', {
    class: {
      'hidden': _vm.activeSection !== 'add-photo'
    },
    attrs: {
      "id": "add-photo"
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-xl shadow-lg p-6"
  }, [_c('div', {
    staticClass: "text-center mb-6"
  }, [_c('i', {
    staticClass: "inline-block h-10 w-10 mask mask-photo bg-secondary mb-4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-xl font-bold text-primary mb-3 uppercase"
  }, [_vm._v("Ma photo de profil")]), _vm._v(" "), _c('p', {
    staticClass: "text-md text-gray-700"
  }, [_vm._v("\n                            Afin de bénéficier d'une interface plus personnelle merci de bien vouloir ajouter une photo de profil.\n                        ")])]), _vm._v(" "), _c('form', {
    staticClass: "hidden",
    attrs: {
      "method": "post",
      "id": "photoprofil",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    ref: "inputphoto",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "change-photo-profil"
    },
    on: {
      "change": _vm.savePhoto
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "w-full bg-primary text-white font-semibold rounded-lg shadow-lg hover:bg-primary-hover transition-colors text-md py-4 px-6 flex items-center justify-center gap-3 mb-4",
    attrs: {
      "id": "photo-trigger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerPhoto($event)
      }
    }
  }, [_c('span', [_vm._v("Ajouter ma photo")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arrow-right bg-white"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "block text-center text-gray-600 hover:text-primary transition-colors py-2",
    attrs: {
      "to": "home",
      "id": "ignore"
    }
  }, [_vm._v("\n                        Pas maintenant\n                    ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0473caa7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Config.vue
// module id = 997
// module chunks = 0